import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `By Surprise by Henri Michaux | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In By Surprise, Henri Michaux recounts in vivid detail the dislocations or déplacements of a psychedelic sojourn, where the vicissitudes of the mind are wrested in a kaleidoscopic “paraphysics”. Across bursts of observation as dizzying as the trip itself,  Michaux probes the affectations of the real and the exaltations of the as-yet unknown. With a preface by Allen Ginsberg on Michaux as humble “genius,” a keeper of visions and dreams, By Surprise is steeped in the thrillingly protean.
`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Special/Michaux_Back.png', '../../Series-Special/Michaux_Side_v2.png', '../../Series-Special/Michaux_Front_v2.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>By Surprise</h1>
            <div className='productAuthor'>Henri Michaux</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416581'} />
            <div className='productPrice'>$16.99 USD</div>
          </div>

          <div className='productDescription'>In <em>By Surprise</em>, Henri Michaux recounts in vivid detail the dislocations or déplacements of a psychedelic sojourn, where the vicissitudes of the mind are wrested in a kaleidoscopic “paraphysics”. Across bursts of observation as dizzying as the trip itself,  Michaux probes the affectations of the real and the exaltations of the as-yet unknown. With a preface by Allen Ginsberg on Michaux as humble “genius,” a keeper of visions and dreams, <em>By Surprise</em> is steeped in the thrillingly protean.
          </div>
          <div className='productDescription'>
            <p>Leaving behind a corpus of nearly 10,000 drawings and over 30 volumes of poetry, the Belgian-born French avant-garde figure <strong>Henri Michaux</strong> (1899-1984) was described by John Ashbery as “hardly a painter, hardly even a writer, but a conscience—the most sensitive substance yet discovered for registering the fluctuating anguish of day-to-day, minute-to-minute living.” With close ties to surrealist and existentialist circles, Michaux modelled his own distinct artistry through a commitment to the revelatory power of a chosen medium, whether literary or artistic. Notable works in English translation include his <em>Plume</em> cycle, a dialogue with a Chaplinesque personification of the errant pen, as well as the travel memoir <em>A Barbarian in Asia</em>, the illustrated volume <em>Stroke by Stroke</em>, and the compilation, <em>Darkness Moves</em>.</p>
          </div>
          <div className='productMetadata'>
            <div>Special Edition</div>
            <div>Spring 2026</div>
            <div>ISBN 979-8-9904165-8-1</div>
            <div>4.125 x 2.75 inches</div>
            <div>120 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}